module.exports = __webpack_public_path__ + "static/media/gotoAppiOS.b704973e.png";